import { Component, OnInit, AfterContentInit } from '@angular/core';
import { EstoqueService } from './estoque.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
  selector: 'app-estoque',
  templateUrl: './estoque.component.html',
  providers: [EstoqueService],
})
export class EstoqueComponent implements OnInit, AfterContentInit {

  public estoques: any[] = [];

  public form: FormGroup = null;
  public id = 0; // representa o id do modelo. Se 0 novo cadastro, Se > 0 editando
  public isProcessing = false;
  public isEditing = false;
  public voids: string[] = [];
  public maxRowsVoids = 7;

  public autorizacoes: UsuarioAutorizacoes;

  constructor(
    private estoqueService: EstoqueService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService

  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('Estoque');
  }

  ngOnInit() {
    this.listar();
    this.resetForm();
  }

  public listar(): void {
    this.estoqueService.buscarTodos().subscribe((response: any) => {
      this.estoques = response;
      this.setVoids();
    });
  }

  public resetForm(): void {
    this.form = new FormGroup(
      {
        id: new FormControl(0),
        nome: new FormControl('', [Validators.required])
      }
    );
  }

  public reset(): void {
    this.id = 0;
    this.isProcessing = false;
    this.isEditing = false;
    this.resetForm();
  }

  public buscarPorId(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.estoqueService.buscarPorId(id).subscribe(

      (response: any) => {
        this.form.get('nome').setValue(response.nome);
        this.form.get('id').setValue(response.id);
        this.id = id;
        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.isProcessing = true;

    this.estoqueService.submit(this.form.value).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.listar();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }

  public setVoids(): void {
    this.voids = [];
    if (this.estoques.length < this.maxRowsVoids) {
      for (let i = this.estoques.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.estoqueService.delete(id).subscribe(

      (response: any) => {
        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }
        this.reset();
        this.listar();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    this.form.get('nome').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }

}
